import {Box, Typography} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {ElevationApp} from "../ElevationApp";
import {MdStickPick} from "../model/view/MdViewSettings";
import {RibbonButton, RibbonGroup} from "./Ribbon";
import {cancelPick} from "./selectedTab/helpers";

// the ribbon while an action (Split By, Join) waits for the user to click a stick. It
// is the only tab shown, so the user either picks a stick on the canvas or cancels.
export function StickPickTab(props: {app: ElevationApp; pick: MdStickPick}) {
    return (
        <>
            <RibbonGroup label={props.pick.title}>
                <Box sx={{display: "flex", alignItems: "center", height: "100%", px: 1, maxWidth: 320}}>
                    <Typography sx={{fontSize: 13}}>{props.pick.instructions}</Typography>
                </Box>
            </RibbonGroup>
            <RibbonGroup label="Actions">
                <RibbonButton icon={<CloseIcon />} label="Cancel" shortcut="Esc" onClick={() => cancelPick(props.app)} />
            </RibbonGroup>
        </>
    );
}
